export default class WipQiDetails {
    qiHoldDetailId: number;
    wipTicketId: number;
    location: string;
    quantity: number;
    qiHold:number;

    constructor(){
        this.qiHoldDetailId = 0;
        this.wipTicketId = 0;
        this.location = "";
        this.quantity = 0;
        this.qiHold = 0;
    }
}